import { BlogTitle, BlogBody, BlogWrapper, ReadTime, BlogImage } from "../components/blog/blog.style.jsx"
import { AboutContentWrapper, HorizontalLine, ImportantWord } from "../components/about-page/about-page.styles.jsx"
import { blogs } from "../blogs.jsx"
import { useNavigate } from "react-router-dom"
import React from "react"
import { renderToStaticMarkup } from "react-dom/server"

const Blog = () => {
  var navigate = useNavigate();

  return (
    <BlogWrapper>
      {
        blogs.map((blog) => <BlogContainer blog={blog} navigate={navigate}/>)
      }
    </BlogWrapper>
  )
}

const BlogContainer = ({blog , navigate}) => (
  <AboutContentWrapper style={{flexDirection: "column", alignItems: 'start' }}>
    <BlogImage src={blog.image} />
    <BlogTitle>
      {blog.title}
    </BlogTitle>
    <ReadTime>
      {blog.readtime} <ImportantWord style={{textTransform: "none"}}>minute</ImportantWord> read
    </ReadTime>
    <HorizontalLine />
    <BlogBody>
      <SnippetComponent  componentElement={blog.body}/> <br /><br />
      <ImportantWord><span style={{cursor: "pointer"}} onClick={() => navigate("/blog/" + blog.id)}>Read More</span></ImportantWord> 
    </BlogBody>
  </AboutContentWrapper>
)


/**
 * Convert a React component to a snippet component
 * - preserves line breaks from <br> and headers
 * - removes other tags
 * - truncates to charLimit
 */
export function SnippetComponent({ componentElement, charLimit = 300 }) {
  // Render component to HTML string
  const html = renderToStaticMarkup(componentElement);

  // Remove all tags except <br> and <h1>
  // Keep both opening <h1> and closing </h1>
  const keepBrAndH1 = html.replace(/<(?!br\s*\/?|\/?h1)[^>]+>/gi, "");

  // Truncate to character limit
  const truncated = keepBrAndH1.slice(0, charLimit);

  // Split by <br> to render lines
  const lines = truncated.split(/<br\s*\/?>/i);

  return (
    <>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {/* dangerouslySetInnerHTML lets us render <h1> if present */}
          <span dangerouslySetInnerHTML={{ __html: line }} />
          {i < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
      ...
    </>
  );
}




export default Blog